module.exports = __webpack_public_path__ + "bf94e1870d8f5b32084acb9b31cc4273.svg";